import styled from 'styled-components'

export const ContainerOfColumns = styled.div`
`

export const ColumnsList = styled.ul`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 500px;
  margin: 0;
  list-style: none;
  padding: .7rem;
  display: flex;
  flex-direction: column;
  gap: .7rem;
  background-color: #F4F4F4;
  border-radius: .7rem;
`

export const ColumnLI = styled.li`
  background-color: #fff;
  padding: 14px 16px;
  border-radius: .5rem;
  border: 1px solid #EBEBEB;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 16px;
`

export const ColumnInfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`

export const ColumnName = styled.div`
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-weight: 700;
  color: #303030;
  line-height: 150%;
`

export const ColumnDesc = styled.div`
  font-family: "Inter", Helvetica;
  font-size: 12px;
  font-weight: 400;
  color: #696969;
  line-height: 150%;
`

export const Select = styled.select`
  padding: 8px 0;
  min-width: 5rem;
  border-radius: 8px;
  border: 1px solid #EBEBEB;
  background-color: #F4F4F4;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  color: #303030;
  cursor: pointer;
  outline: none;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #C4C4C4;
    border-color: #EBEBEB;
  }

  &:hover {
    border-color: #0090D3;
  }

  &:focus {
    border-color: #0090D3;
    box-shadow: 0 0 0 2px rgba(0, 144, 211, 0.2);
  }
`
